/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { useEffect, useState } from "react";
import { UAParser } from "ua-parser-js";

/**
 * Returns true if user agent is determined to be a Windows device
 */
export const useIsWindows = (): boolean => {
	const [isWindows, setIsWindows] = useState(false);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const parser = new UAParser();
			const os = parser.getOS();
			const isMacOS = os.name === "Windows";
			setIsWindows(isMacOS);
		}
	}, []);
	return isWindows;
};

/**
 * Returns true if user agent is determined to be a Linux device
 */
export const useIsLinux = (): boolean => {
	const [isLinux, setIsLinux] = useState(false);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const parser = new UAParser();
			const os = parser.getOS();
			const isMacOS = os.name === "Linux";
			setIsLinux(isMacOS);
		}
	}, []);
	return isLinux;
};

/**
 * Returns true if user agent is determined to be a Windows device
 */
export const useIsMac = (): boolean => {
	const [isMac, setIsMac] = useState(false);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const parser = new UAParser();
			const os = parser.getOS();
			const isMacOS = os.name === "Mac OS";
			setIsMac(isMacOS);
		}
	}, []);
	return isMac;
};

/**
 * Returns true if user agent is determined to be a mobile device
 */
export const useIsMobile = (): boolean => {
	const [isMobile, setIsMobile] = useState(false);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const parser = new UAParser();
			const device = parser.getDevice();
			const isMobileDevice = device.type === "mobile" || device.type === "tablet";
			setIsMobile(isMobileDevice);
		}
	}, []);
	return isMobile;
};

export const useOS = (): UAParser.IOS | undefined => {
	const [os, setOS] = useState<UAParser.IOS | undefined>(undefined);
	useEffect(() => {
		//return setOS({ name: "Linux", version: "" });
		if (typeof window !== "undefined") {
			const parser = new UAParser();
			const os = parser.getOS();
			setOS(os);
		}
	}, []);
	return os;
};

export const useOsName = (): string => {
	const os = useOS();
	const name = os?.name || "";
	const cleanOS = name.replace(/\s/g, "");
	return cleanOS.toLowerCase();
};
